import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userService } from "@/services/userService";

export const userKeys = {
  all: ['users'],
  single: (id) => [...userKeys.all, id],
};

export const useCreateUser = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => userService.createUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
    ...options,
  });
};

export const useUpdateUser = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => userService.updateUser(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: userKeys.single(id) });
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
    ...options,
  });
};

export const useDeleteUser = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => userService.deleteUser(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
    ...options,
  });
};

export const useMassDeleteUsers = (options) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids) => userService.massDelete(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
    ...options,
  });
}; 